import {forceLogoutForCollaborationReset} from './forceLogoutForCollaborationReset';
import {isAbnormalClose} from './yjsServerReset';

/**
 * After the editor has connected once, an abnormal WebSocket drop forces sign-out
 * so y-websocket cannot auto-reconnect with a stale Y.Doc (typical on Docker restart → 1006).
 * Clean/expected closes (1000 normal, 1001 going away — e.g. tab navigation) are left alone
 * so y-websocket can reconnect normally instead of signing the user out.
 */
export function installCollaborationConnectionGuard(provider) {
    let intentionalTeardown = false;
    let hasEstablishedConnection = false;

    const onStatus = ({status}) => {
        if (status === 'connected') {
            hasEstablishedConnection = true;
        }
    };

    const onSynced = (isSynced) => {
        if (isSynced) {
            hasEstablishedConnection = true;
        }
    };

    const onConnectionClose = (event) => {
        const code = event?.code ?? 'unknown';
        if (intentionalTeardown || !hasEstablishedConnection || !isAbnormalClose(code)) {
            return;
        }

        console.info('[y-websocket] collaboration connection lost — forcing sign-out', {
            code,
            reason: event?.reason ?? '',
        });

        try {
            provider.shouldConnect = false;
        } catch (_) {
            // ignore
        }

        forceLogoutForCollaborationReset({
            code,
            reason: event?.reason ?? '',
            trigger: 'connection-close',
        });
    };

    provider.on('status', onStatus);
    provider.on('synced', onSynced);
    provider.on('connection-close', onConnectionClose);

    const originalDestroy = provider.destroy.bind(provider);
    provider.destroy = () => {
        intentionalTeardown = true;
        try {
            provider.shouldConnect = false;
        } catch (_) {
            // ignore
        }
        provider.off('status', onStatus);
        provider.off('synced', onSynced);
        provider.off('connection-close', onConnectionClose);
        originalDestroy();
    };

    return provider;
}
